/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S7_Li4_TermInputs */

const tr_iade_iptal_s7_li4_term = /** @type {(inputs: Iade_Iptal_S7_Li4_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Süre sonu:`)
};

const en_iade_iptal_s7_li4_term = /** @type {(inputs: Iade_Iptal_S7_Li4_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End of term:`)
};

const de_iade_iptal_s7_li4_term = /** @type {(inputs: Iade_Iptal_S7_Li4_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laufzeitende:`)
};

const ru_iade_iptal_s7_li4_term = /** @type {(inputs: Iade_Iptal_S7_Li4_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Окончание срока:`)
};

/**
* | output |
* | --- |
* | "End of term:" |
*
* @param {Iade_Iptal_S7_Li4_TermInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s7_li4_term = /** @type {((inputs?: Iade_Iptal_S7_Li4_TermInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S7_Li4_TermInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s7_li4_term(inputs)
	if (locale === "de") return de_iade_iptal_s7_li4_term(inputs)
	if (locale === "ru") return ru_iade_iptal_s7_li4_term(inputs)
	return tr_iade_iptal_s7_li4_term(inputs)
});